import { get, set } from 'lodash';

import { FIELD_PATHS } from '@funnels/constants';
import { Company, StoreEmployment } from '@funnels/types';

export function fixCompany(employment: StoreEmployment, reduxStoreCompanies: Company[]) {
  const companyClientId = get({ employments: [employment] }, FIELD_PATHS.EMPLOYMENT_COMPANY_CLIENT_ID(0));

  // doesn't have a property
  if (!companyClientId) {
    //clean up the employment-company link
    set({ employments: [employment] }, FIELD_PATHS.EMPLOYMENT_COMPANY_ID(0), undefined);
    return;
  }

  const company = reduxStoreCompanies.find((c) => c.clientId === companyClientId);

  if (!company || !company.id) {
    // abort employment request if company create fail
    throw new Error('Employments create fail');
  }

  set({ employments: [employment] }, FIELD_PATHS.EMPLOYMENT_COMPANY_ID(0), company.id);
}

// Because BE will omit companyClientId in response so need another fix for the companyClientId for employment
export function fixCompanyClientId(responseEmployment: StoreEmployment, requestEmployments: StoreEmployment[]) {
  const employmentClientId = get({ employments: [responseEmployment] }, FIELD_PATHS.EMPLOYMENT_CLIENT_ID(0));

  const requestEmployment = requestEmployments.find((e) => e.clientId === employmentClientId);

  const requestEmploymentCompanyClientId = get(
    { employments: [requestEmployment] },
    FIELD_PATHS.EMPLOYMENT_COMPANY_CLIENT_ID(0)
  );

  // doesn't have a property
  if (!requestEmploymentCompanyClientId) {
    return;
  }

  set(
    { employments: [responseEmployment] },
    FIELD_PATHS.EMPLOYMENT_COMPANY_CLIENT_ID(0),
    requestEmploymentCompanyClientId
  );
}

export function fixEmploymentId(applicantEmployment: StoreEmployment, reduxStoreEmployments: StoreEmployment[]) {
  const employmentClientId = get({ employments: [applicantEmployment] }, FIELD_PATHS.EMPLOYMENT_CLIENT_ID(0));

  const storeEmployment = reduxStoreEmployments.find((e) => e.clientId === employmentClientId);

  const employmentId = get({ employments: [storeEmployment] }, FIELD_PATHS.EMPLOYMENT_ID(0));

  // create case
  if (!employmentId) {
    return;
  }

  set({ employments: [applicantEmployment] }, FIELD_PATHS.EMPLOYMENT_ID(0), employmentId);
}
